export default 'https://tme.understood.org/assets/mask_world_eye.043f78f4.glb'